<div class="flex flex-row w-full justify-between gap-y-20">
	<div class="relative group cursor-pointer mx-auto translate-y-10" (click)="toDofus()" (keydown.enter)="toDofus()">
		<img src="/assets/images/max_button/max_button_marvel_rivals_background.png" alt="Background Dofus"
             class="transition transform duration-300 absolute top-0 z-[-999] scale-[102%] group-hover:brightness-200 group-hover:-translate-y-5 translate-y-4 translate-x-0.5" />

		<img src="/assets/images/max_button/max_button_dofus_foreground.png" alt="Foreground Dofus"
             class="transition transform duration-300 z-10 group-hover:brightness-50 group-hover:-translate-y-11"/>

		<img src="/assets/images/max_button/max_button_dofus_logo.webp" alt="Logo Marvel Rivals"
             class="hidden sm:block absolute left-1/2 top-1/2
			  -translate-x-[40%] -translate-y-[90%] h-18
			  md:h-26 md:-translate-x-[50%] md:-translate-y-[110%]">

		<svg width="165" height="249" viewBox="0 0 165 249" fill="none" xmlns="http://www.w3.org/2000/svg"
		     class="absolute transition-transform transform duration-300 hidden lg:block
			   top-22 group-hover:-translate-y-12 group-hover:-translate-x-3">
			<path d="M164.354 246.531L90.4778 219.969L92.1379 222.459L162.279 248.191L164.354 246.531Z" fill="#F9ECEA"/>
			<path d="M26.1472 72.6312L0 27.8074L30.7126 0L49.8043 27.8074L26.1472 52.7095L33.2029 65.5756L26.1472 72.6312Z" fill="#F9ECEA"/>
			<path d="M47.7291 114.135L30.7126 82.177L34.863 78.4417L49.8043 108.324L47.7291 114.135Z" fill="#F9ECEA"/>
		</svg>

		<svg width="49" height="65" viewBox="0 0 49 65" fill="none" xmlns="http://www.w3.org/2000/svg"
			 class="absolute transition-transform transform duration-300 hidden lg:block
			 top-52 sm:left-1 group-hover:-translate-x-5 group-hover:-translate-y-5">
			<path d="M8.5 0L48.5 64.5L33.5 58.5L0 8L8.5 0Z" fill="#F9ECEA"/>
		</svg>

		<svg width="42" height="153" viewBox="0 0 42 153" fill="none" xmlns="http://www.w3.org/2000/svg"
			 class="absolute transition-transform transform duration-300 hidden lg:block
			 -top-4 translate-x-70 group-hover:-translate-y-22 group-hover:translate-x-68.75">
			<path d="M42 153L17 4.5L0 0L31.5 137L42 153Z" fill="#F9ECEA"/>
		</svg>
	</div>

	<div class="relative group cursor-pointer mx-auto " (click)="toOverwatch()" (keydown.enter)="toOverwatch()">
		<img src="/assets/images/max_button/max_button_overwatch_background.png" alt="Background Overwatch"
		     class="transition transform duration-300 absolute top-0 z-[-999] scale-[102%] group-hover:brightness-200 group-hover:-translate-y-12 -translate-y-2 -translate-x-1" />

		<img src="/assets/images/max_button/max_button_overwatch_foreground.png" alt="Foreground Overwatch"
		     class="transition transform duration-300 z-10 group-hover:brightness-50 group-hover:-translate-y-8"/>

		<img src="/assets/images/max_button/max_button_overwatch.png" alt="Logo Overwatch"
		     class="hidden sm:block absolute left-1/2 top-1/2
			  -translate-x-[50%] -translate-y-[40%] h-20 sm:h-20 md:h-26 md:-translate-x-[50%] md:-translate-y-[20%]">

		<svg width="35" height="200" viewBox="0 0 35 200" fill="none" xmlns="http://www.w3.org/2000/svg"
		     class="absolute transition-transform transform duration-300 hidden lg:block
			top-5 left-10 group-hover:-translate-x-2 group-hover:-translate-y-24">
			<path d="M-0.000465517 8.4988L22.9983 190.909L33.5788 199.51L22.8573 107.035L34.7088 100.652L25.2249 -0.000449373L-0.000465517 8.4988Z" fill="#F9ECEA"/>
		</svg>

		<svg width="31" height="71" viewBox="0 0 31 71" fill="none" xmlns="http://www.w3.org/2000/svg"
		     class="absolute transition-transform transform duration-300 hidden lg:block
		top-4 right-2 group-hover:translate-x-5 group-hover:-translate-y-10 -rotate-22">
			<path d="M0 51L19.5 0.5L30.5 28.5L12.5 71L0 51Z" fill="#F9ECEA"/>
		</svg>

		<svg width="16" height="108" viewBox="0 0 16 108" fill="none" xmlns="http://www.w3.org/2000/svg"
		     class="absolute transition-transform transform duration-300 hidden lg:block
		bottom-2 right-16 group-hover:translate-x-2 group-hover:translate-y-10">
			<path d="M0.000123747 107.184L3.12139 0.000457369L15.0121 10.5769L10.6852 98.291L0.000123747 107.184Z" fill="#F9ECEA"/>
		</svg>

	</div>

	<div class="relative group cursor-pointer mx-auto " (click)="togglePokemonMenu()" (keydown.enter)="togglePokemonMenu()">
		<img src="/assets/images/max_button/max_button_pokemon_background.png" alt="Background Pokemon"
             class="transition transform duration-300 absolute top-0 z-[-999] scale-[102%] group-hover:brightness-200 group-hover:-translate-y-12 -translate-y-2 -translate-x-1" />

		<img src="/assets/images/max_button/max_button_pokemon_foreground.png" alt="Foreground Pokemon"
             class="transition transform duration-300 z-10 group-hover:brightness-50 group-hover:-translate-y-8"/>

		<img src="/assets/images/max_button/max_button_pokemon.png" alt="Logo Pokemon"
             class="hidden sm:block absolute left-1/2 top-1/2
			  -translate-x-[70%] -translate-y-[40%] h-12 md:h-22 md:-translate-x-[65%] md:-translate-y-[50%]">

		<svg width="149" height="60" viewBox="0 0 149 60" fill="none" xmlns="http://www.w3.org/2000/svg"
			class="absolute transition-transform transform duration-300 hidden lg:block
			bottom-38 left-4 group-hover:translate-x-3 group-hover:-translate-y-6">
			<path d="M36 38L148.5 0L131.5 10L36 39.5V38Z" fill="#F9ECEA"/>
			<path d="M4.5 59.5L0 15L20.5 26L15.5 55L4.5 59.5Z" fill="#F9ECEA"/>
		</svg>

		<svg width="34" height="128" viewBox="0 0 34 128" fill="none" xmlns="http://www.w3.org/2000/svg"
			class="absolute transition-transform transform duration-300 hidden lg:block
			-top-5 left-12 group-hover:-translate-x-2 group-hover:-translate-y-24 rotate-10">
			<path d="M0 0.5L11.5 116L23.5 128L19 67L33.5 48.5L29 0.5H0Z" fill="#F9ECEA"/>
		</svg>

		<svg width="31" height="71" viewBox="0 0 31 71" fill="none" xmlns="http://www.w3.org/2000/svg"
		class="absolute transition-transform transform duration-300 hidden lg:block
		top-45 right-8 group-hover:translate-x-5 group-hover:-translate-y-10 rotate-10">
			<path d="M0 51L19.5 0.5L30.5 28.5L12.5 71L0 51Z" fill="#F9ECEA"/>
		</svg>

		<div
			[ngClass]="isPokemonMenuOpen() ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'"
			class="z-50 top-1/2 left-1/2 -translate-x-2/3 absolute w-38 md:w-44 h-fit py-4 [clip-path:polygon(0%_100%,0%_9%,60.7%_1.75%,37.7%_7.7%,100%_0%,100%_91.4%,37.7%_98.8%,60.7%_92.8%,0%_100%)]">
			<img src="/assets/images/max_button/max_button_pokemon_menu_background.svg" alt="Background menu pokémon" class="absolute inset-0 w-full h-full object-cover object-center z-[-1]">
			<div class="flex flex-col gap-2">
				<button
					(click)="toPokemonUnite()"
					(keydown.enter)="toPokemonUnite()"
					class="flex flex-row items-center gap-2 cursor-pointer px-4 py-2 hover:-translate-y-2 duration-300"
				>
					<img src="/assets/images/max_button/max_button_pokemon_pokeball.png" alt="Pokeball" class="h-4 md:h-6 lg:h-8">
					<p class="text-nowrap text-sm md:text-base lg:text-lg text-white font-bold uppercase">Pokémon Unite</p>
				</button>
				<button
					(click)="toPokemonVGC()"
					(keydown.enter)="toPokemonVGC()"
					class="flex flex-row items-center gap-2 cursor-pointer px-4 py-2 hover:-translate-y-2 duration-300"
				>
					<img src="/assets/images/max_button/max_button_pokemon_pokeball.png" alt="Pokeball" class="h-4 md:h-6 lg:h-8">
					<p class="text-nowrap text-sm md:text-base lg:text-lg text-white font-bold uppercase">Pokémon VGC</p>
				</button>
			</div>
		</div>
	</div>
</div>
